"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Countries = void 0;
var Countries;
(function (Countries) {
    Countries["Netherlands"] = "Netherlands";
    Countries["UnitedKingdom"] = "United Kingdom";
})(Countries || (exports.Countries = Countries = {}));
